/* eslint max-len: ["error", 300] */
import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import DocumentTitle from 'react-document-title';
import {getQuestions, setOrder} from '../modules/Questions';
import {showNewQuestion, showHome} from '../modules/Navigation';
import {getUser} from '../modules/Authenticate';
import {getContextualLists} from '../modules/Contextual';
import Home from './Home';
import {emitPageView} from '../lib/mz';
import IntroPanel from './components/IntroPanel';
import SearchForm from './components/SearchForm';
import {searchQuestions, changeKeyword} from '../modules/Search';

@connect((state) => ({
  questions: state.questions.questions,
  order: state.questions.order,
  total: state.questions.total,
  offset: state.questions.offset,
  limit: state.questions.limit,
  loadingQuestions: state.questions.loadingQuestions,
  tag: state.questions.tag,
  user: state.authenticate.user,
  widget: state.environment.widget,
  widgetType: state.environment.widgetType,
  context: state.environment.widgetConfig.context,
  error: state.status.error,
  ready: state.status.ready,
  q: state.search.q,
  contextType: state.environment.widgetConfig.contextType,
}), (dispatch) => ({
  setup: () => {
    dispatch(setup());
  },
  getQuestions: (order, tag, context, limit, offset, append) => {
    dispatch(getQuestions(order, tag, context, limit, offset, append));
  },
  getUser: () => {
    dispatch(getUser());
  },
  orderClick: (order, tag, context) => ((e) => {
    e.preventDefault();
    dispatch(setOrder(order, tag, context));
  }),
  showNewQuestionClick: (tag) => ((e) => {
    e.preventDefault();
    dispatch(showNewQuestion(tag));
  }),
  showHomeClick: (widget, context) => (e) => {
    e.preventDefault();
    dispatch(showHome(widget, context));
  },
  getContextualLists: (lists, context) => {
    dispatch(getContextualLists(lists, context));
  },
  searchSubmit: (q, contextType) => {
    dispatch(searchQuestions(q, 0, contextType));
  },
  onChangeKeyword: (q) => {
    dispatch(changeKeyword(q));
  },
}))

// eslint-disable-next-line react/prefer-stateless-function
export default class HomeContainer extends Component {
  static propTypes = {
    getUser: PropTypes.func.isRequired,
    getQuestions: PropTypes.func.isRequired,
    questions: PropTypes.array,
    loadingQuestions: PropTypes.bool.isRequired,
    user: PropTypes.object,
    tag: PropTypes.string,
    setup: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    offset: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    orderClick: PropTypes.func.isRequired,
    showNewQuestionClick: PropTypes.func.isRequired,
    showHomeClick: PropTypes.func.isRequired,
    getContextualLists: PropTypes.func.isRequired,
    routeParams: PropTypes.object.isRequired,
    widget: PropTypes.bool.isRequired,
    widgetType: PropTypes.string.isRequired,
    context: PropTypes.string,
    error: PropTypes.object,
    ready: PropTypes.bool,
    q: PropTypes.string,
    searchSubmit: PropTypes.func.isRequired,
    onChangeKeyword: PropTypes.func.isRequired,
    contextType: PropTypes.string,
  };

  componentWillMount() {
    this.props.getUser();
    if (!this.props.questions) {
      this.props.getQuestions(
        this.props.order,
        this.props.routeParams.tag,
        this.props.context,
        this.props.offset,
        this.props.limit);
    }
    if (!this.props.widget) {
      this.props.getContextualLists([
        {name: 'most-viewed-unanswered', order: 'viewed', tag: this.props.routeParams.tag, showUnanswered: true},
        {name: 'most-popular-tags'},
      ], this.props.context);
    }
  }

  componentDidMount() {
    emitPageView({type: 'answers-home'});
  }

  render() {
    const {
      questions,
      total,
      offset,
      limit,
      loadingQuestions,
      user,
      order,
      orderClick,
      showNewQuestionClick,
      showHomeClick,
      tag,
      context,
      widget,
      widgetType,
      q,
      searchSubmit,
      onChangeKeyword,
      contextType,
    } = this.props;

    const activeButtonClass = 'simple-tab__tab simple-tab__tab--active';
    const inactiveButtonClass = 'simple-tab__tab';
    const latestClassName = order === 'latest' ? activeButtonClass : inactiveButtonClass;
    const viewsClassName = order === 'viewed' ? activeButtonClass : inactiveButtonClass;
    const votesClassName = order === 'voted' ? activeButtonClass : inactiveButtonClass;

    const welcome = (
      <IntroPanel askQuestionClick={showNewQuestionClick(tag)}>
        {!widget &&
          [<div className="intro-panel__footer-child" key="onlyTemp1UntilWeMovetoInsideComponent">
            <div className="simple-tab" role="group">
              <button className={latestClassName} type="button" onClick={orderClick('latest', tag, context)}>
                Latest
              </button>
              <button className={viewsClassName} type="button" onClick={orderClick('viewed', tag, context)}>
                Views
              </button>
              <button className={votesClassName} type="button" onClick={orderClick('voted', tag, context)}>
                Votes
              </button>
            </div>
          </div>,
            <div className="intro-panel__footer-child" key="onlyTemp2UntilWeMovetoInsideComponent">
              <SearchForm q={q} contextType={contextType} searchSubmit={searchSubmit} changeKeyword={onChangeKeyword} widgetType={widgetType} />
            </div>,
          ] }
      </IntroPanel>
    );

    const home = (
      <Home
        getQuestions={this.props.getQuestions}
        questions={questions}
        loadingQuestions={loadingQuestions}
        order={order}
        tag={tag}
        offset={offset}
        limit={limit}
        total={total}
        orderClick={orderClick}
        user={user}
        showHomeClick={showHomeClick}
        showNewQuestionClick={showNewQuestionClick}
        widget={widget}
        context={context}
      />
    );

    const title = tag ? `Teacher Q&A - for ${tag}` : 'Teacher Q&A';
    return widget ?
      (<div>
        {welcome}
        {home}
      </div>)
      :
      (<DocumentTitle title={title}>
        <div>
          {welcome}
          <div className="l-app-padding">
            {home}
            <hr className="content-breaker" />
            <div className="margin-bottom-ml">
              <h3 className="heading heading--semi-bold heading--underline">About Teacher Q&A</h3>
              <div className="text--xs">
                <p>This is a Question and Answer site for educators to help each other with any queries - whether about a curriculum, regulations, or the best classroom resource for a particular lesson.</p>
                <p>Questions that are not questions (e.g. discussion on a topical event) will be closed and redirected to our Community forums.</p>
                <p>You can receive email notifications of activity on questions to which you have contributed.&nbsp;
                  <a href="/preference-centre/subscribe/question-event" className="link link--colored">Subscribe</a> / <a href="/preference-centre/unsubscribe/question-event" className="link link--colored">unsubscribe</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>);
  }
}
